import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
import { StyleSheetManager } from 'styled-components';
import { StoreProviders } from './context/StoreProviders';
import { SceneContextProvider } from './context/sceneContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StoreProviders>
    <SceneContextProvider>
      <StyleSheetManager shouldForwardProp={(prop) => prop.startsWith('$') ? false : true} >
        <App />
      </StyleSheetManager>
    </SceneContextProvider>
  </StoreProviders>
);
